<div class="m-2">
  <div class="d-flex">
    <div class="flex-grow-1">
      <kendo-label *ngIf="isLabelVisible()" [for]="getControlName()" [text]="getLabel()">
        <span *ngIf="isRequired()" class="required">*</span>
      </kendo-label>
      <kendo-textbox *ngIf="isControlVisible()" [hidden]="isAutocompleteControlVisible()" [id]="getControlName()" [name]="getControlName()" [(ngModel)]="localValue"
        [required]="isRequired()" [readonly]="true">
      </kendo-textbox>
      <kendo-combobox *ngIf="isAutocompleteControlVisible()" [ngClass]="{'ng-invalid': isInvalid(), 'ng-touched': isTouched()}" [data]="addressesSubject | async" [loading]="searchInProgress" textField="addressLine" valueField="addressLine"
        [filterable]="true" (filterChange)="handleFilter($event)" (valueChange)="onAddressChange($event)" [disabled]="isSearchDisabled()">
      </kendo-combobox>
    </div>
    <div class="address-input-button-container ms-4 d-md-flex d-block align-items-end">
      <button class="address-input-button" kendoButton (click)="onEditClick()">
        <span class="k-icon k-i-edit address-input-button-icon"></span>
      </button>
      <button *ngIf="isDeleteVisible()" class="address-input-button address-delete-button mt-2 mt-md-0 ms-0 ms-md-2" kendoButton (click)="onDeleteClick()">
        <span class="k-icon k-i-delete address-input-button-icon"></span>
      </button>
    </div>
  </div>
</div>
